<template>
  <div class="GroupReportThird">
    <a-table :columns="columns" :pagination="tableRelevant.tablePagination" :loading="tableRelevant.tableLoading" :locale="tableRelevant.locale" :dataSource="tableRelevant.tableDataSource">
      <a-table slot="expandedRowRender" slot-scope="parentText" rowKey="id" :loading="parentText.childTableLoading" :columns="innerColumns" :data-source="parentText.details" :pagination="false">
        <div slot="abilityTypeName" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">{{ item.abilityTypeName }}</div>
        </div>
        <div slot="firstAbilityName" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">{{ item.firstAbilityName }}</div>
        </div>
        <div slot="secondAbilityName" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">{{ item.secondAbilityName }}</div>
        </div>
        <div slot="scoreSwitch" slot-scope="text, record">
          <div class="self_td" v-for="item in record.abilityDetails" :key="item.id">
            <a-switch checked-children="开" un-checked-children="关" :disabled="IsDetails" :checked="item.scoreSwitch" @click="ScoreSwitchChange(record, item)" />
          </div>
        </div>
      </a-table>
    </a-table>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
const columns = [
  { title: '机构名称', dataIndex: 'organizationName' },
  { title: '课程名称', dataIndex: 'organizationCourseName' },
  { title: '资源名称', dataIndex: 'courseName' },
  { title: '课时名称', dataIndex: 'courseSessionResourceName' },
  { title: '参与人数', key: 'userCount', dataIndex: 'userCount' },
]
const innerColumns = [
  { title: '任务名称', key: 'contentName', dataIndex: 'contentName' },
  { title: '能力类型', key: 'abilityTypeName', class: 'testClass', align: 'center', scopedSlots: { customRender: 'abilityTypeName' } },
  { title: '一级能力', key: 'firstAbilityName', class: 'testClass', align: 'center', scopedSlots: { customRender: 'firstAbilityName' } },
  { title: '二级能力', key: 'secondAbilityName', class: 'testClass', align: 'center', scopedSlots: { customRender: 'secondAbilityName' } },
  { title: '算分开关', key: 'scoreSwitch', class: 'testClass', align: 'center', scopedSlots: { customRender: 'scoreSwitch' } },
  { title: '参与人数', key: 'userCount', dataIndex: 'userCount' },
]
export default {
  name: 'GroupReportThird',
  props: {
    IsDetails: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      columns,
      tableRelevant: tableRelevant.call(this, this.getList),
      tableExpandedRowKeys: [], //表格展开的行
      innerColumns,
      ReportInfo: this.$store.getters['organization/getReportInfo'],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.GetGroupReportProjectCoursechildDetail(this.ReportInfo.id)
        .then((res) => {
          const { status, data, message } = res
          this.tableRelevant.tableDataSource = data
            .map((v) => {
              return v.groupCourseInfos.map((item) => ({ ...v, ...item }))
            })
            .flat(2)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    // 展开行
    expandedRowsChange(expandedRowKeys) {
      if (expandedRowKeys.length > 1) {
        this.tableExpandedRowKeys = [expandedRowKeys.pop()]
      } else {
        this.tableExpandedRowKeys = expandedRowKeys
      }
    },
    getContents(expanded, record) {
      if (expanded) {
        // record.childTableLoading = true
      }
    },
    // 编辑算分开关
    ScoreSwitchChange(record, item) {
      item.scoreSwitch = !item.scoreSwitch
    },
  },
}
</script>

<style scoped>
v-deep .ant-table-tbody .testClass {
  padding: 0 !important;
}
.self_td {
  height: 54px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  justify-content: center;
}
</style>
